export enum MatchType {
    Any = "Any",
    All = "All",
}
